import { Company } from "src/types";
import { put } from "../utils";

export async function updateCompany(user: Partial<Company>): Promise<Company> {
  return (await put({ path: "outdefine_hire/company", body: user })).body?.company as Company;
}
